<app-error-handler onlyFor="sites:list" alignment="center" displayAs="widget">
  <div class="d-flex justify-content-around contacts-option tabs-content">
    <ng-container *fcHasPermission="'sites:create'; else createSiteDisabled">
      <span id="widgetSitesCreateButton" (click)="(bPageLoaded) ? recordDialog() : ''" class="span-links">
        <fa-icon [icon]="['fas', 'plus-circle']" class="text-success mr-1"></fa-icon>
        {{ 'create_site' | translate }}
      </span>
    </ng-container>
    <ng-template #createSiteDisabled>
      <span id="widgetSitesCreateButton" class="span-links disabled" matTooltip="{{ 'forbidden_action_error' | translate }}">
        <fa-icon [icon]="['fas', 'plus-circle']" class="text-default"></fa-icon>
        {{ 'create_site' | translate }}
      </span>
    </ng-template>
    <ng-container class="form-inline mt-12">
      <span id="widgetSiteLinkButton" (click)="linkSites()" class="span-links">
        <fa-icon [icon]="['fas', 'plus-circle']" class="text-success"></fa-icon>
        {{ 'link_sites' | translate }}
      </span>
    </ng-container>
  </div>
  <div>
    <div class="sites-body">
      <div class="container" style="max-width: 40vw;">
        <div class="row pt-2 pb-2">
          <div class="col-sm-6 pt-1">
            <span class="module-title">
              <fa-icon [icon]="['fa', 'map-marker-alt']" aria-hidden="true"></fa-icon>
              &nbsp;
              {{ 'sites' | translate }}
            </span>
          </div>
          <div class="col-sm-6 pr-2">
            <nav class="pagination-section" class="float-right">
              <ul class="pagination">
                <refresh-pagination-btn id="widgetSitesRefreshButton" (refresh)="fetchList()" [isDisabled]="bLoading"></refresh-pagination-btn>
                <li [ngClass]="(listingService.strFirstValue != listingService.strCurrentValue && listingService.strCurrentValue != '') ? 'active' : 'disabled'" class="page-item">
                  <a id="widgetSitesPreviousButton" class="page-link" aria-label="first" (click)="fetchList('prev')">
                    <fa-icon [icon]="['far', 'chevron-left']" aria-hidden="true"></fa-icon>
                  </a>
                </li>
                <li [ngClass]="(listingService.strNextValue != '') ? 'active' : 'disabled'" class="page-item">
                  <a id="widgetSitesNextButton" class="page-link" aria-label="first" (click)="fetchList('next')">
                    <fa-icon [icon]="['far', 'chevron-right']" aria-hidden="true"></fa-icon>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div *ngIf="arContractSites.length < 1">
          <div class="row border-top" *ngIf="!bLoading">
            <span class="no-content">
            {{ 'no_sites' | translate }}
            </span>
          </div>
          <div class="row border-top" *ngIf="bLoading">
            <span class="no-content">
            <fa-icon [icon]="['fas', 'spinner']" [spin]="true" aria-hidden="true"></fa-icon>
            {{ 'loading' | translate }}
            </span>
          </div>
        </div>
        <div class="row border-top pt-2 pb-2" *ngFor="let contractSite of arContractSites" [id]="'widgetSitesRecord' + contractSite.id">
        <div class="col-sm-1 align-middle heigh">
          <fa-icon class="fa-2x pt-1" matTooltip="{{ (contractSite.site_disable_maintenance == true ? 'disabled_maintenance' : 'enabled_maintenance') | translate }}" [icon]="['fas', 'circle']" [ngClass]="[(contractSite.site_disable_maintenance) ? 'text-danger' : 'text-success']"></fa-icon>
        </div>
        <div class="col-sm-9">
          <div class="truncate">
            <a id="widgetSitesLabel" matTooltip="# {{ contractSite.site_number }}" class="pointer" href="/#/sites/{{ contractSite.site_id }}">
              <span class="align-middle"># {{ contractSite.site_number }}</span>
            </a>
          </div>
          <div class="truncate">
            <a id="widgetSitesLabel" matTooltip="{{ contractSite.site_text }}" class="pointer" href="/#/sites/{{ contractSite.site_id }}">
              <span class="align-middle">{{ contractSite.site_text }}</span>
            </a>
          </div>
        </div>
        <div class="col-sm-2">
          <div class="row">
            <div class="col-12 pl-2">
              <ng-container *fcHasPermission="'sites:edit'; else disabledEditButton">
                <fa-icon id="widgetSitesEditButton" class="text-success pointer float-right" [icon]="['fas', 'pencil']" (click)="openSiteForm(contractSite.site_id)"></fa-icon>
              </ng-container>
              <ng-template #disabledEditButton>
                <fa-icon id="widgetSitesEditButton" class="disabled float-right" [icon]="['fas', 'pencil']" matTooltip="{{ 'forbidden_action_error' | translate }}"></fa-icon>
              </ng-template>
            </div>
            <div class="col-12 pl-2">
              <ng-container *fcHasPermission="'sites:edit'; else disableUnlinkButton">
                <fa-icon id="widgeSitesUnlink" class="text-warning pointer float-right" [icon]="['fas', 'unlink']" (click)="unlinkRecord(contractSite.id)"></fa-icon>
              </ng-container>
              <ng-template #disableUnlinkButton>
                <fa-icon id="widgeSitesUnlink" class="disabled float-right" [icon]="['fas', 'trash-alt']" matTooltip="{{ 'forbidden_action_error' | translate }}"></fa-icon>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</app-error-handler>